<template>
  <v-app style="font-family: '微软雅黑'" v-resize="onResize">
    <v-content
      v-if="
        $vuetify.breakpoint.name != 'xs' ||
        $route.path == '/Register_mobile' ||
        $route.path == '/MobilePublicity' ||
        $route.path == '/PrivacyPolicy_mobile' ||
        $route.path == '/ServiceAgreement_mobile'||
        $route.path == '/CountyPrices'||
        $route.path == '/Login_mobile'
      "
    >
      <home-navi
        v-if="
          !(hideTopNaviUrls.indexOf($route.path) > -1) &&
          !/\/Archive/.test($route.path) && $route.path != '/viewMapSource'
        "
        style="z-index: 999"
        class="mediaShow"
      />

      <router-view v-if="isRouterAlive" :key="$route.fullPath"/>
      <!-- <div style="width: 100%;height: 2000px"></div> -->
      <!-- <home-footer v-if="$route.path !== '/DataSetInfo'" /> -->
      <home-footer
        v-if="
          $route.path == '/' ||
          $route.path == '/GeneralTraffic/Home' ||
          $route.path == '/AnnualPurchase/Home' ||
          $route.path == '/rsManage' ||
          $route.path == '/process' ||
          $route.path == '/Payment' ||
          $route.path == '/Contract' ||
          $route.path == '/MyRSservice' ||
          $route.path == '/RSsserviceManage'||
          $route.path == '/Instruction'||
          $route.path == '/MyRSservices'||
          $route.path == '/Feedback'||
          $route.path == '/ProcessRep'||
          $route.path == '/CountyPrices'
        "
      />
      <onlineService v-if="!(hideOnlineServiceUrls.indexOf($route.path) > -1)"></onlineService>
    </v-content>
    <NoMobile
      v-if="
        $vuetify.breakpoint.name == 'xs' &&
        $route.path != '/Register_mobile' &&
        $route.path != '/PrivacyPolicy_mobile' &&
        $route.path != '/ServiceAgreement_mobile'&&
        $route.path != '/MobilePublicity'&&
        $route.path != '/CountyPrices'&&
        $route.path != '/Login_mobile'
      "
    />
  </v-app>
</template>

<script>
import HomeNavi from "./components/newHomeNavi";
import HomeFooter from "./components/HomeFooter";
import NoMobile from "./views/access/NoMobile";
import OnlineService from "./components/onlineService/icon.vue";
import { CHANNEL_PARAMS } from "@/globalConfig";

export default {
  name: "App",
  components: {
    HomeFooter,
    HomeNavi,
    NoMobile,
    OnlineService
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data: () => ({
    isRouterAlive: true,
    hideOnlineServiceUrls:[
      "/Login",
      "/Register",
      "/Register_mobile",
      "/PrivacyPolicy_mobile",
      "/ServiceAgreement_mobile",
      "/MobilePublicity",
      "/404",
      "/ElectronicContract",
      "/ServiceAgreement_mobile",
      "/PrivacyPolicy_app",
      "/AnnualPurchase/annualPurchaseData",
      "/AnnualPurchase/annualSubmitOrder",
      "/GeneralTraffic/purchaseData",
      "/onlineService/Home",
      '/imageSegmentation',
      '/vectoryLibrary'

    ],
    hideTopNaviUrls: [
      "/vectoryLibrary",
      "/imageSegmentation",
      "/Login_mobile",
      "/ForgetPassword",
      "/Authentication",
      "/UserEditPassword",
      "/UserBoundPhone",
      "/UserCenter",
      "/MyOrderAppraise",
      "/MyOrderManage",
      "/MyOrderDetail_program",
      "/MyOrderDetail",
      "/MyApplication",
      "/ApplicationCenter",
      "/DataSetInfo",
      "/Login",
      "/UserAddressManage",
      "/UserInvoiceManage",
      "/Register",
      "/Register_mobile",
      "/PrivacyPolicy_mobile",
      "/ServiceAgreement_mobile",
      "/MobilePublicity",
      "/404",
      "/onlineService/Home"
    ],
  }),
  computed: {
    lang() {
      return this.$vuetify.lang.current;
    },
  },

  watch: {
    lang(val) {
      localStorage.setItem("lang", val);
    },
  },
  created() {
     // 在页面加载时读取sessionStorage
     if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    }
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })


    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.onResize);
    this.$store.state.innerHeight = window.innerHeight;

  },
  mounted() {
    this.channelLanding();
    if (localStorage.getItem("lang")) {
      this.$vuetify.lang.current = localStorage.getItem("lang");
    } else {
      if (
        (navigator.browserLanguage || navigator.language).toLowerCase() ===
        "zh-cn"
      ) {
        this.$vuetify.lang.current = "zhHans";
      } else {
        this.$vuetify.lang.current = "en";
      }
    }
    //识别屏幕缩放比例
    // console.log("识别屏幕缩放比例");
    // console.log(this.detectZoom());
    this.$store.state.screenZoom = this.detectZoom();
  },
  methods: {
    detectZoom() {
      var ratio = 0,
        screen = window.screen,
        ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      } else if (~ua.indexOf("msie")) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      } else if (
        window.outerWidth !== undefined &&
        window.innerWidth !== undefined
      ) {
        ratio = window.outerWidth / window.innerWidth;
      }
      if (ratio) {
        ratio = Math.round(ratio * 100);
      }
      return ratio;
    },
    channelLanding() {
      const q = this.$route.query;
      // agentCompany 类渠道（水经注等，白名命中才落地；hasOwnProperty 防原型链误命中）
      const company = q.agentCompany;
      if (company && Object.prototype.hasOwnProperty.call(CHANNEL_PARAMS, company)) {
        localStorage.setItem("agentCompany", company);
        CHANNEL_PARAMS[company].forEach((name) => {
          localStorage.setItem(name, q[name] || "");
        });
      }
    },
    onScroll() {
      this.$store.state.pageYOffset = window.pageYOffset;
    },
    onResize() {
      this.$store.state.innerHeight = window.innerHeight;
      this.$store.state.windowSize = {
        x: window.innerWidth,
        y: window.innerHeight,
      }; //access用到了
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style lang="scss">
@import "./global.scss";
html, body {
  overflow-x: hidden;
}

@media screen and (max-width: 800px) {
  .mediaShow{
    display:none;
  }
}
</style>
